import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { download } from '@bingads-webui/download-service';
import { withUiBlock } from '@bingads-webui/uiblocker';
import template from './template.pug';
import { jsdataBhc } from '../../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
/**
 * Class representing a navigation tabs for HotelCenter Intelligence
 * @extends View
 */
export default class MatchReport extends DeterministicView {
  /**
  * Initializes MatchReport
  * @returns {undefined}
  */
  initialize({ perfMarker = null }) {
    this.i18n = i18n;
    if (perfMarker) {
      this.perfMarker = perfMarker.createChild('HotelCenterMatchReport');
      this.perfMarker.willInit();
    }
    this.pageInitialize();
  }

  get events() {
    return {
      'click .match-report-download-button': this.onMatchReportDownload,
    };
  }

  get template() {
    return template;
  }


  getState() {
    return {
      feedId: this.model.get('id'),
    };
  }

  onMatchReportDownload() {
    const { feedId } = this.getState();
    const odataOptions = {
      cacheResponse: false,
      url: `/Customers(:advertisercustomer_id)/HotelFeeds(${feedId})`,
    };

    return jsdataBhc.HotelFeed.find(feedId, odataOptions)
      .then((response) => {
        download(response.matchingReportUri);
      });
  }

  pageInitialize() {
    const odataOptions = {
      cacheResponse: false,
      url: '/Customers(:advertisercustomer_id)/HotelFeeds',
    };
    const queryOptions = {
      where: { status: 'LIVE' },
      limit: 1,
    };

    jsdataBhc.HotelFeed.findAll(queryOptions, odataOptions)
      .then((response) => {
        if (response.length === 0) {
          this.setState({ hasResult: false });
        } else {
          this.setState({ hasResult: true });
          const state = this.formatMatchReportRes(_.first(response));
          if (this.perfMarker) {
            this.perfMarker.willRender();
          }
          this.setState(state);
          if (this.perfMarker) {
            this.perfMarker.done();
          }
        }
      })
      .finally(withUiBlock(this.el));
  }

  formatMatchReportRes(data) {
    const feed = _.extend(data, {
      ingenstionTime: this.i18n.formatDate(new Date(data.ingenstionTime), { skeleton: 'yMMMdHms' }),
      matchedPercentage: this.i18n.formatPercent(data.machedCount / data.hotelsCount),
    });

    return {
      id: feed.Id,
      versionInfo: this.i18n.getString('HotelCenter_MatchReport_Content_Label_FeedVersion', feed),
      submittedInfo: this.i18n.getString('HotelCenter_MatchReport_Content_Label_SubmittedInfo', feed),
      matchedInfo: this.i18n.getString('HotelCenter_MatchReport_Content_Label_MatchedInfo', feed),
      overclusteredInfo: this.i18n.getString('HotelCenter_MatchReport_Content_Label_OverclusteredInfo', feed),
    };
  }
}
